import ShareDirService from "@/services/shareDir.service";

export default {
    namespaced: true,

    state: {
        token: null,
        currentDir: "",
        fileArray: [],
        errorMessage: "",
    },

    getters: {
        token: state => state.token,
        currentDir: state => state.currentDir,
        fileArray: state => state.fileArray,
        errorMessage: state => state.errorMessage,
    },

    mutations: {
        SET_TOKEN(state, token) {
            state.token = token;
        },

        SET_CURRENT_DIR(state, currentDir) {
            state.currentDir = currentDir;
        },

        SET_FILE_ARRAY(state, files) {
            state.fileArray = files;
        },

        SET_ERROR_MESSAGE(state, message) {
            state.errorMessage = message;
        },

        CLEAR(state) {
            state.token = null;
            state.currentDir = "";
            state.fileArray = [];
            state.errorMessage = "";
        },
    },

    actions: {
        async createShareLink({ commit }) {
            const res =
                await ShareDirService.createShareLink();

            const token = res.data.token;

            commit("SET_TOKEN", token);

            return token;
        },

        async fileList(
            { state, commit },
            subDir = ""
        ) {
            try {
                const res =
                    await ShareDirService.getShareDirFileList(
                        state.token,
                        subDir
                    );

                commit(
                    "SET_CURRENT_DIR",
                    res.data.currentDir
                );

                commit(
                    "SET_FILE_ARRAY",
                    res.data.files
                );

                commit(
                    "SET_ERROR_MESSAGE",
                    ""
                );

                return res.data;
            } catch (error) {
                const message =
                    error.response?.data ||
                    "파일 목록을 불러오지 못했습니다.";

                commit(
                    "SET_ERROR_MESSAGE",
                    message
                );

                throw error;
            }
        },
    },
};